import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/Common/Icon/icon';
import NextRedIcon from '../../assets/next-red.svg';
import NextIcon from '../../assets/next.svg';
import { getOutletTagCategory } from '../../hooks/utils';
import classes from './category.module.css'; // variant "tag" is an outlet tag category block (HBF-145): grey background, shown in the top row

var SubCategoryBox = function SubCategoryBox(_ref) {
  var _getOutletTagCategory;

  var subcategory = _ref.subcategory,
      variant = _ref.variant;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var handleIsHovered = function handleIsHovered() {
    return setIsHovered(!isHovered);
  };

  var name = ((_getOutletTagCategory = getOutletTagCategory(subcategory)) === null || _getOutletTagCategory === void 0 ? void 0 : _getOutletTagCategory.label) || subcategory.name;
  var rootClass = variant === 'tag' ? classes.outletTagCategoryLink : classes.outletCategoryLink;
  return React.createElement("div", {
    className: rootClass,
    onMouseEnter: handleIsHovered,
    onMouseLeave: handleIsHovered
  }, React.createElement("div", {
    className: classes.outletCategoryName
  }, React.createElement("h3", null, name)), React.createElement("div", {
    className: classes.shopOutlet + ' my-8 items-center grid grid-cols-2'
  }, React.createElement("h5", null, "Shop"), React.createElement("span", null, React.createElement(Link, {
    to: '/' + subcategory.url_path,
    className: "flex w-[36px] h-[36px] md_w-[48px] md_h-[48px]",
    "aria-label": "Go to ".concat(name, " Outlet page")
  }, React.createElement(Icon, {
    src: isHovered ? NextIcon : NextRedIcon,
    alt: 'Shop ' + name
  })))));
};

export default SubCategoryBox;